"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const CoreContext_1 = require("../../contexts/CoreContext");
const JoinLauncherContext_1 = require("../../contexts/join-launcher/JoinLauncherContext");
const ButtonsFactory_1 = require("../../helpers/ButtonsFactory");
const DownloadState_1 = require("../../models/DownloadState");
const Environment_1 = require("../../models/Environment");
const JoinInfo_1 = require("../../models/JoinInfo");
const TelemetryEvents_1 = require("../../models/telemetry/TelemetryEvents");
const LauncherService_1 = require("../../services/LauncherService");
const Logger_1 = require("../../services/Logger");
const Trans_1 = require("../common/Trans");
const Header_1 = require("../common/v2/Header");
const Launching_1 = require("../common/v2/Launching");
const UnsupportedEnvironment_1 = require("../common/v2/UnsupportedEnvironment");
require("./ModernViewRenderer.scss");
class ModernViewRenderer extends React.Component {
    constructor(props) {
        super(props);
        this.reportSuccessPanelViewAfterPstnCheck = false;
        this.finalPanelViewReported = false;
        this.loadingPanelViewReported = false;
    }
    render() {
        return (React.createElement(CoreContext_1.CoreContextConsumer, null, ({ environment }) => {
            return (React.createElement(JoinLauncherContext_1.JoinLauncherContextConsumer, null, ({ downloadState, joinInfo }) => {
                return this.renderContent(environment, downloadState, joinInfo);
            }));
        }));
    }
    shouldShowDownloadInProgress(downloadState) {
        return downloadState.step === DownloadState_1.DownloadStep.InProgress || downloadState.step === DownloadState_1.DownloadStep.PotentiallyCompleted;
    }
    shouldShowIntermediateProgress(downloadState) {
        return downloadState.step == DownloadState_1.DownloadStep.Intermediate;
    }
    shouldShowIeEdgeLaunchedFailed() {
        return this.props.launchResult === LauncherService_1.LaunchResults.UserCancelled ||
            this.props.launchResult === LauncherService_1.LaunchResults.NoHandler ||
            this.props.launchResult === LauncherService_1.LaunchResults.NotAttempted;
    }
    shouldShowIeEdgeLauncherSucceeded() {
        return this.props.launchResult === LauncherService_1.LaunchResults.Success ||
            this.props.launchResult === LauncherService_1.LaunchResults.PreviouslySucceeded;
    }
    skipPanelViewAfterPstnCheck() {
        this.reportSuccessPanelViewAfterPstnCheck = true;
    }
    renderContent(environment, downloadState, joinInfo) {
        const { showContinueInBrowser, waitsForLWJCheck, buttonsFactory, } = this.props;
        switch (environment.browserName) {
            case Environment_1.Browsers.Edge: {
                const instructionsPanelTitle = this.getInstructionsPanelTitle(downloadState, environment.browserName, joinInfo.type);
                const instructionsPanelText = this.getInstructionsPanelText(downloadState);
                if (this.shouldShowIeEdgeLauncherSucceeded()) {
                    return this.renderSelection(buttonsFactory.getEdgeSuccessButtons(), instructionsPanelTitle, instructionsPanelText);
                }
                else if (this.shouldShowIeEdgeLaunchedFailed()) {
                    return this.renderSelection(buttonsFactory.getEdgeFailureButtons(), instructionsPanelTitle, instructionsPanelText);
                }
                else {
                    return this.renderLoadingPage();
                }
            }
            case Environment_1.Browsers.MSIE:
                // Restricting IE to version 11 on W8+
                // Checking a launch method as IE11 on W7 doesn't have msLaunch method present. In that case we should act as being in e.g. Firefox.
                if (environment.isNativeClientSupportedOS && this.props.launchMethod === LauncherService_1.LaunchMethods.MsLaunch) {
                    this.skipPanelViewAfterPstnCheck();
                    const instructionsPanelTitle = this.getInstructionsPanelTitle(downloadState, environment.browserName, joinInfo.type);
                    const instructionsPanelText = this.getInstructionsPanelText(downloadState);
                    if (this.shouldShowIeEdgeLauncherSucceeded()) {
                        const buttons = environment.isWindows10 ?
                            buttonsFactory.getIE11SuccessButtons(showContinueInBrowser) :
                            buttonsFactory.getIE11NoEdgeSuccessButtons(showContinueInBrowser);
                        return this.renderSelection(buttons, instructionsPanelTitle, instructionsPanelText);
                    }
                    else if (this.shouldShowIeEdgeLaunchedFailed()) {
                        const buttons = environment.isWindows10 ?
                            buttonsFactory.getIE11FailureButtons(showContinueInBrowser) :
                            buttonsFactory.getIE11NoEdgeFailureButtons(showContinueInBrowser);
                        return this.renderSelection(buttons, instructionsPanelTitle, instructionsPanelText);
                    }
                    else {
                        return this.renderLoadingPage();
                    }
                }
                else { // IE < 11 || IE == 11 && Win < 8
                    return this.renderUnsupportedBrowsers(buttonsFactory, environment, downloadState, waitsForLWJCheck, showContinueInBrowser);
                }
            case Environment_1.Browsers.Chrome:
            case Environment_1.Browsers.EdgeChromium:
                if (environment.isNativeClientSupportedOS) {
                    const instructionsPanelTitle = this.getInstructionsPanelTitle(downloadState, environment.browserName, joinInfo.type);
                    const instructionsPanelText = this.getInstructionsPanelText(downloadState);
                    let buttons;
                    if (environment.canonicalOs === Environment_1.CanonicalOperatingSystems.Mac) {
                        buttons = buttonsFactory.getChromeMacOsButtons(environment.isEdgeAnaheim);
                    }
                    else if (environment.canonicalOs === Environment_1.CanonicalOperatingSystems.Win) {
                        buttons = buttonsFactory.getChromeWindowsButtons(environment.isEdgeAnaheim);
                    }
                    else {
                        buttons = buttonsFactory.getChromeLinuxButtons();
                    }
                    return this.renderSelection(buttons, instructionsPanelTitle, instructionsPanelText);
                }
                else {
                    // no download, go directly to web
                    return this.renderSelection(buttonsFactory.getChromeUnsupportedOsButtons(environment.isEdgeAnaheim), this.props.enableVariant10 ? "hdr_generic_variant_10" : "hdr_generic");
                }
            case Environment_1.Browsers.Safari:
                if (environment.isWebClientSupportedBrowser && environment.isNativeClientSupportedOS) {
                    const instructionsPanelTitle = this.getInstructionsPanelTitle(downloadState, environment.browserName, joinInfo.type);
                    const instructionsPanelText = this.getInstructionsPanelText(downloadState);
                    return this.renderSelection(buttonsFactory.getSafariMacOsButtons(), instructionsPanelTitle, instructionsPanelText);
                }
                else {
                    return this.renderUnsupportedBrowsers(buttonsFactory, environment, downloadState, waitsForLWJCheck, showContinueInBrowser);
                }
            // FF and other browsers
            default:
                return this.renderUnsupportedBrowsers(buttonsFactory, environment, downloadState, waitsForLWJCheck, showContinueInBrowser);
        }
    }
    getInstructionsPanelTitle(downloadState, browserName, joinType) {
        if (this.shouldShowDownloadInProgress(downloadState)) {
            if (this.props.installerAutoDownloadEnabled) {
                return "hdr_coachmark_post_download";
            }
            return "hdr_during_download";
        }
        if (this.shouldShowIntermediateProgress(downloadState)) {
            return "hdr_during_download_auto_download";
        }
        if (browserName === Environment_1.Browsers.Edge || browserName === Environment_1.Browsers.MSIE) {
            if (this.shouldShowIeEdgeLauncherSucceeded()) {
                if (joinType === JoinInfo_1.JoinType.ShareEmail) {
                    return "hdr_share_email_launcher_success";
                }
                return "hdr_launcher_success";
            }
            else if (this.shouldShowIeEdgeLaunchedFailed()) {
                return "hdr_launcher_w10_edge_ie_failure";
            }
        }
        if (joinType === JoinInfo_1.JoinType.ShareEmail) {
            return "hdr_share_email";
        }
        if (this.props.enableVariant10) {
            return "hdr_generic_variant_10";
        }
        return "hdr_generic";
    }
    getInstructionsPanelText(downloadState) {
        if (this.shouldShowDownloadInProgress(downloadState) && this.props.installerAutoDownloadEnabled) {
            return "txt_coachmark_post_download_auto_download";
        }
        return "";
    }
    renderUnsupportedBrowsers(buttonsFactory, environment, downloadState, waitsForLWJCheck, continueInBrowser) {
        let instructionsPanelTitle;
        let instructionsPanelText;
        if (environment.isNativeClientSupportedOS) {
            if (this.props.enableVariant10) {
                instructionsPanelTitle = this.shouldShowDownloadInProgress(downloadState) ? "hdr_during_download" : "hdr_generic_variant_10";
            }
            else if (this.props.installerAutoDownloadEnabled) {
                if (this.shouldShowDownloadInProgress(downloadState)) {
                    instructionsPanelTitle = "hdr_coachmark_post_download";
                }
                else if (this.shouldShowIntermediateProgress(downloadState)) {
                    instructionsPanelTitle = "hdr_during_download_auto_download";
                }
                else {
                    instructionsPanelTitle = "hdr_generic";
                }
            }
            else {
                instructionsPanelTitle = this.shouldShowDownloadInProgress(downloadState) ? "hdr_during_download" : "hdr_generic";
            }
            instructionsPanelText = this.getInstructionsPanelText(downloadState);
            let buttons;
            if (environment.canonicalOs === Environment_1.CanonicalOperatingSystems.Mac) {
                this.skipPanelViewAfterPstnCheck();
                buttons = buttonsFactory.getOtherBrowsersMacOsButtons(continueInBrowser);
            }
            else if (environment.canonicalOs === Environment_1.CanonicalOperatingSystems.Win) {
                this.skipPanelViewAfterPstnCheck();
                buttons = buttonsFactory.getOtherBrowsersWindowsButtons(continueInBrowser, environment.isWindows10);
            }
            else {
                this.skipPanelViewAfterPstnCheck();
                buttons = buttonsFactory.getOtherBrowsersLinuxButtons(continueInBrowser);
            }
            return this.renderSelection(buttons, instructionsPanelTitle, instructionsPanelText);
        }
        else {
            // no download, go directly to web if LMJ
            if (waitsForLWJCheck && this.props.pstnIsAvailable === undefined) {
                return this.renderLoadingPage();
            }
            else if (continueInBrowser) {
                this.skipPanelViewAfterPstnCheck();
                // TODO: invoke automatic launch as there is only LMJ button
                return this.renderSelection(buttonsFactory.getUnsupportedOsButtons(), this.props.enableVariant10 ? "hdr_generic_variant_10" : "hdr_generic");
            }
            else {
                return this.renderNotSupportedPage();
            }
        }
    }
    // Reports panel view with shown buttons, as LMJ button is asynchronous we should wait for resolution
    // of PSTN availability check to report LMJ button visibility.
    reportSuccessPanelView(name, joinInfo, props) {
        if (!this.reportSuccessPanelViewAfterPstnCheck || this.props.pstnIsAvailable !== undefined) {
            if (!this.finalPanelViewReported) {
                const panelViewEvent = new TelemetryEvents_1.PanelViewEvent(name, joinInfo, Object.assign(Object.assign({}, props), { launchResult: this.props.launchResult }));
                Logger_1.default.logUserBiPanelView(panelViewEvent);
                this.finalPanelViewReported = true;
            }
        }
    }
    renderSelection(buttons, instructionsPanelTitle, instructionsPanelText) {
        return buttons.length === 0 ? this.renderNotSupportedPage() : (React.createElement(JoinLauncherContext_1.JoinLauncherContextConsumer, null, ({ joinInfo }) => {
            const buttonNames = buttons.map((item) => ButtonsFactory_1.ButtonKey[item.key]).toString();
            this.reportSuccessPanelView("join_launcher_loaded", joinInfo, { "DataBag.availableOptions": buttonNames });
            return (React.createElement("div", { className: "modernViewRenderer" },
                this.props.enableVariant10 ? (React.createElement(Header_1.Header, { title: "", text: instructionsPanelText, className: "variant10Header" },
                    React.createElement(Trans_1.Trans, { i18n: instructionsPanelTitle },
                        React.createElement("b", null,
                            React.createElement(Trans_1.Trans, { i18n: "hdr_generic_variant_10_prompt_action" }))))) : (React.createElement(Header_1.Header, { title: instructionsPanelTitle, text: instructionsPanelText })),
                React.createElement("div", { className: "vl" }),
                React.createElement("div", { className: "content", id: "buttonsbox" }, buttons)));
        }));
    }
    renderNotSupportedPage() {
        return (React.createElement(JoinLauncherContext_1.JoinLauncherContextConsumer, null, ({ joinInfo }) => {
            if (!this.finalPanelViewReported) {
                const panelViewEvent = new TelemetryEvents_1.PanelViewEvent("join_launcher_unsupported", joinInfo);
                Logger_1.default.logUserBiPanelView(panelViewEvent);
                this.finalPanelViewReported = true;
            }
            const onClick = () => {
                const panelActionEvent = new TelemetryEvents_1.PanelActionEvent(TelemetryEvents_1.PanelActionScenarioNames.ModernView, TelemetryEvents_1.ModuleNames.LearnMore, joinInfo);
                Logger_1.default.logUserBiPanelAction(panelActionEvent);
            };
            return React.createElement(UnsupportedEnvironment_1.UnsupportedEnvironment, { onLearnMoreButtonClick: onClick });
        }));
    }
    renderLoadingPage() {
        return (React.createElement(JoinLauncherContext_1.JoinLauncherContextConsumer, null, ({ joinInfo }) => {
            if (!this.loadingPanelViewReported) {
                const panelViewEvent = new TelemetryEvents_1.PanelViewEvent("join_launcher_loading", joinInfo);
                Logger_1.default.logUserBiPanelView(panelViewEvent);
                this.loadingPanelViewReported = true;
            }
            return React.createElement(Launching_1.Launching, { text: "hdr_launching_teams_app" });
        }));
    }
}
exports.ModernViewRenderer = ModernViewRenderer;
